// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"550":"2f3ca3ab","626":"1d01e38d"}[chunkId] + ".chunk.js";
};